import React, {Component} from 'react';
import {connect} from 'react-redux';
import Master from './containers/Master';
import LocationDetails from './containers/Locations/LocationDetails';
import Menus from './containers/Menu/Menus';
import Settings from './containers/Settings';
import LocationList from './containers/Locations/LocationList';
import Login from './containers/Login';
import CompanyUsers from './containers/Companies/CompanyUsers';
import AddRestaurant from './containers/Locations/AddRestaurant';
import AddMenu from './containers/Menu/AddMenu';
import StationsList from './containers/ActiveStationsList';
import CompanyList from './containers/Companies/CompanyList';
import WebsiteHome from './containers/Website/WebsiteHome';
import MenuHome from './containers/Menu/MenuHome';
import FeatureRoute from './components/FeatureRoute';
import RoleRoute from './components/RoleRoute';
import ChangePassword from './containers/ChangePassword';
import WaitlistSettings from './containers/Waitlist/WaitlistSettingsContainer';
import {
  Route,
  Switch,
} from 'react-router-dom';
import { withRouter } from 'react-router-dom'
import {Logout as LogoutAction} from './actions/auth.actions';


/**
 * @augments {Component<{loggedIn: boolean, logoutAction(): any, companyRole:string}, {}>}
 */
class RootPage extends Component {

  componentDidMount(){
    if (this.props.loggedIn && !this.props.companyRole){
      this.props.logoutAction();
    }
  }
  render(){
    return (
      <Master loggedIn={this.props.loggedIn} logout={this.props.logoutAction}>
        {this.props.loggedIn?
          /* Content Routes go here.. To configure the content drop down menus and required routes, update /components/AppSubMenu.js */
          <Switch>
            <Route exact path="/" component={LocationList}/>
            <FeatureRoute features={['readyWebsite']} path="/website/:page" component={WebsiteHome}/>
            <FeatureRoute features={['readyWebsite']} path="/website" component={WebsiteHome}/>
            <FeatureRoute features={['readyWebsite']} path="/menus/add" component={AddMenu}/>
            <FeatureRoute features={['readyWebsite']} path="/menus" component={Menus}/>
            <FeatureRoute features={['readyWebsite']} path="/websites/:websiteId/menu/" component={MenuHome}/>
            
            <FeatureRoute features={['readyWebsite']} path="/company/:companyId/website/:page" component={WebsiteHome}/>
            <FeatureRoute features={['readyWebsite']} path="/company/:companyId/website" component={WebsiteHome}/>
            <FeatureRoute features={['readyWebsite']} path="/company/:companyId/menus/add" component={AddMenu}/>
            <FeatureRoute features={['readyWebsite']} path="/company/:companyId/menus" component={Menus}/>
            <FeatureRoute features={['readyWebsite']} path="/company/:companyId/websites/:websiteId/menu/" component={MenuHome}/>
            
            <FeatureRoute features={['waitlist']} path="/waitlist" component={WaitlistSettings}/>
            <FeatureRoute features={['waitlist']} path="/company/:companyId/waitlist" component={WaitlistSettings}/>

            <RoleRoute roles={['iQ Admin']} path="/companies" component={CompanyList}/>
            <Route path="/location/:locationId/:page" component={LocationDetails}/>
            <Route path="/location/add" component={AddRestaurant}/>
            <Route path="/location/:locationId/" component={LocationDetails}/>
            <Route path="/locations" component={LocationList}/>
            <Route path="/company/:companyId/location/:locationId/:page" component={LocationDetails}/>
            <Route path="/company/:companyId/location/add" component={AddRestaurant}/>
            <Route path="/company/:companyId/location/:locationId/" component={LocationDetails}/>
            <Route path="/company/:companyId/locations" component={LocationList}/>
            <Route path="/users" component={CompanyUsers}/>
            <Route path="/stations" component={StationsList}/>
            <Route path="/company/:companyId/users" component={CompanyUsers}/>
            <Route path="/company/:companyId/stations" component={StationsList}/>
            <Route path="/settings" component={Settings}/>
          </Switch>
          : <Switch> 
                <Route path="/ChangePassword" component={ChangePassword}/>
                <Route path="/" component={Login}/>
            </Switch>
          }
    </Master>);
  }
}

const mapStateToProps = ({authEndpoint}) => ({
  loggedIn: authEndpoint.token?true: false,
  companyRole: authEndpoint.companyRole
})

const mapDispatchToProps = (dispatch) => ({
  logoutAction: () => dispatch(LogoutAction())
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(RootPage));



// WEBPACK FOOTER //
// ./src/Root.js